<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" routerLink='/'>Covid-19 Tracker</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
            <li class="nav-item active">
                <a class="nav-link" class="btn btn-outline-dark" style="margin: 3px;" routerLink='/'>Home <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" class="btn btn-outline-dark" style="margin: 3px;" routerLink='countries'>Countries</a>
            </li>

        </ul>
    </div>
</nav>